import { render, staticRenderFns } from "./Filters.vue?vue&type=template&id=8421822c&scoped=true"
import script from "./Filters.vue?vue&type=script&lang=ts"
export * from "./Filters.vue?vue&type=script&lang=ts"
import style0 from "./Filters.vue?vue&type=style&index=0&id=8421822c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8421822c",
  null
  
)

export default component.exports